import { render, staticRenderFns } from "./TargetsType.vue?vue&type=template&id=0164cdb3&scoped=true"
import script from "./TargetsType.vue?vue&type=script&setup=true&lang=js"
export * from "./TargetsType.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TargetsType.vue?vue&type=style&index=0&id=0164cdb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0164cdb3",
  null
  
)

export default component.exports